import React, {useState} from "react";
import {Modal} from "../../react/components/ui/spectre/Modal";
import {ModalHeader} from "../../react/components/ui/spectre/ModalHeader";
import {ModalBody} from "../../react/components/ui/spectre/ModalBody";
import {ModalFooter} from "../../react/components/ui/spectre/ModalFooter";
import {getTranslator} from "../../translate";
import {IFacility} from "../types";
import {Button, ButtonGroup, ButtonTypes} from "../../react/components/ui/spectre/buttons";
import {countFactories} from "../Helper/FacilityAggregators";
import {sanitizeForReact} from "../../helper/SanitizeHtml";

const translateDialogue = getTranslator('react/component/Satisfactory/FacilityDeleteModal');

type Props = {
    facility: IFacility,
    delete: () => void,
    close: () => void,
}

export default function FacilityDeleteModal({ facility, close, ...props }: Props) {
    const [inputString, setInputString] = useState<string>('');

    const childrenAmount = countFactories(facility, { facilityIsOne: true }) - 1;
    const saneName = sanitizeForReact(facility.name);

    const isDisabled = childrenAmount !== 0 && inputString !== facility.name;

    return <Modal onClose={() => close()}>
        <ModalHeader showCloseButton={true} title={translateDialogue('deleteFacility')} onClose={() => close()} />
        <ModalBody>
            { childrenAmount === 0
                ? <div dangerouslySetInnerHTML={{__html: translateDialogue('reallyDelete', { NAME: saneName })}}></div>
                : <div dangerouslySetInnerHTML={{__html: translateDialogue('reallyReallyDelete', {NAME: saneName, AMOUNT: childrenAmount.toString()})}}></div>
            }
            { childrenAmount > 0 &&
                <div>
                    <div>{translateDialogue('deletePseudoCaptcha')}</div>
                    <div>
                        <input className='full-width' onChange={e => setInputString(e.target.value)} value={inputString} placeholder={facility.name} />
                    </div>
                </div>
            }
        </ModalBody>
        <ModalFooter>
            <ButtonGroup>
                <Button disabled={isDisabled} onClick={() => props.delete()} buttonTypes={[ButtonTypes.error]}>{translateDialogue('delete')}</Button>
            </ButtonGroup>
        </ModalFooter>
    </Modal>
}
